import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import RouteStatusPage from './RouteStatusPage';

const NotFound: FC = () => {
    const { t } = useTranslation();

    return <RouteStatusPage title={t('error.pageNotFound')} message={t('error.pageNotFoundDetail')} />;
};

export default NotFound;
